/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Platform_Benchmark_HeadingInputs */

const en_platform_benchmark_heading = /** @type {(inputs: Platform_Benchmark_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`What the ${i?.name} API actually does`)
};

const zh_hans1_platform_benchmark_heading = /** @type {(inputs: Platform_Benchmark_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} API 的真实表现`)
};

const pt_br2_platform_benchmark_heading = /** @type {(inputs: Platform_Benchmark_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O que a API para ${i?.name} realmente entrega`)
};

const es_platform_benchmark_heading = /** @type {(inputs: Platform_Benchmark_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lo que realmente hace la API de ${i?.name}`)
};

const fr_platform_benchmark_heading = /** @type {(inputs: Platform_Benchmark_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ce que fait réellement l’API ${i?.name}`)
};

const de_platform_benchmark_heading = /** @type {(inputs: Platform_Benchmark_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Was die ${i?.name}-API tatsächlich leistet`)
};

const ru_platform_benchmark_heading = /** @type {(inputs: Platform_Benchmark_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Что на самом деле делает API ${i?.name}`)
};

const it_platform_benchmark_heading = /** @type {(inputs: Platform_Benchmark_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cosa fa davvero l'API di ${i?.name}`)
};

/**
* | output |
* | --- |
* | "What the {name} API actually does" |
*
* @param {Platform_Benchmark_HeadingInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_benchmark_heading = /** @type {((inputs: Platform_Benchmark_HeadingInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Benchmark_HeadingInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_benchmark_heading(inputs)
	if (locale === "pt-BR") return pt_br2_platform_benchmark_heading(inputs)
	if (locale === "es") return es_platform_benchmark_heading(inputs)
	if (locale === "fr") return fr_platform_benchmark_heading(inputs)
	if (locale === "de") return de_platform_benchmark_heading(inputs)
	if (locale === "ru") return ru_platform_benchmark_heading(inputs)
	if (locale === "it") return it_platform_benchmark_heading(inputs)
	return en_platform_benchmark_heading(inputs)
});